import { render, staticRenderFns } from "./CSummaryItem.vue?vue&type=template&id=49c65784&"
import script from "./CSummaryItem.vue?vue&type=script&lang=js&"
export * from "./CSummaryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports